module.exports = __webpack_public_path__ + "static/img/cover3.d1203c2e.jpg";